// import { allEachConditionDataErrorAtom } from "atoms/Ltool/matrixAtoms";
import { ChartData } from "atoms/Ltool/chartAtoms";
import { Config } from "atoms/Ltool/newConfigAtoms";

export type AllChartDataMap = Record<string, ChartData>;

/** allChartDataAtom の値を受け取り、全てのステータスが error かを判定 */
export function allStatusError(dict: AllChartDataMap): boolean {
    return Object.values(dict).every(item => item.status === 'error');
};

const isNullSeries = (series?: ChartData["data"]["target"] | null): boolean => {
    if (!series || series.length === 0) return true;
    return series.every(value => value == null);
};

/** allChartDataAtom の値を受け取り、全データが空配列または null のみかを判定 */
export function allNullData(dict: AllChartDataMap): boolean {
    return Object.values(dict).every(({ data, status }) => {
        if (status !== 'success') return false;

        const { target, measurement } = data;
        const isTargetNull = isNullSeries(target);
        const isMeasurementNull = isNullSeries(measurement);
        return isTargetNull && isMeasurementNull;
    });
}

/**　configAtom の全フィールドが truthy かどうかを判定する　*/
export const isConfigComplete = (config: Config): boolean => {
    return Boolean(
        config.project_id &&
        config.destination_id &&
        config.lot_id &&
        config.phase_id &&
        config.calculation_id
    );
};

export function areConfigsEqual(a: Config, b: Config): boolean {
    return (
        a.project_id === b.project_id &&
        a.destination_id === b.destination_id &&
        a.lot_id === b.lot_id &&
        a.phase_id === b.phase_id &&
        a.calculation_id === b.calculation_id &&
        a.condition_id === b.condition_id &&
        a.graph_id === b.graph_id
    );
};
